import { api } from "./client";

export const LEAD_STATUSES = [
  { value: "new",       label: "New" },
  { value: "contacted", label: "Contacted" },
  { value: "closed",    label: "Closed" },
];

// Public contact-form submission.
export async function addLead(data) {
  await api.post("/leads", data);
}

// Admin: read and manage leads.
export async function getLeads() {
  const { leads } = await api.get("/leads", { auth: true });
  return leads;
}

export async function setLeadStatus(id, status) {
  await api.patch(`/leads/${id}`, { status }, { auth: true });
}

export async function deleteLead(id) {
  await api.del(`/leads/${id}`, { auth: true });
}
